import { Button } from '@/components/ui/button';
import { Delete } from 'lucide-react';

interface NumberPadProps {
  onDigit: (digit: number) => void;
  onBackspace: () => void;
  onClear: () => void;
  onDeclarationAdd: (value: number) => void;
  declarationsEnabled: boolean;
  disabled?: boolean;
}

export function NumberPad({
  onDigit,
  onBackspace,
  onClear,
  onDeclarationAdd,
  declarationsEnabled,
  disabled = false,
}: NumberPadProps) {
  const digitButtons = [
    [7, 8, 9],
    [4, 5, 6],
    [1, 2, 3],
  ];

  const declarationValues = [20, 50, 100];

  const numbersDisabled = disabled || declarationsEnabled;

  return (
    <div className="flex gap-2 w-full">
      {/* Number pad */}
      <div className="grid grid-cols-3 gap-1.5 flex-1">
        {digitButtons.flat().map((digit) => (
          <Button
            key={digit}
            variant="outline"
            className="h-12 text-lg font-semibold"
            onClick={() => onDigit(digit)}
            disabled={numbersDisabled}
          >
            {digit}
          </Button>
        ))}
        <Button
          variant="outline"
          className="h-12 text-lg font-semibold"
          onClick={() => onDigit(0)}
          disabled={numbersDisabled}
        >
          0
        </Button>
        <Button
          variant="outline"
          className="h-12 text-lg col-span-2"
          onClick={onBackspace}
          disabled={numbersDisabled}
        >
          <Delete className="h-5 w-5" />
        </Button>
      </div>

      {/* Declaration and Clear buttons */}
      <div className="flex flex-col gap-1.5 w-20">
        {declarationValues.map((value) => (
          <Button
            key={value}
            variant="secondary"
            className="h-10 text-sm"
            onClick={() => onDeclarationAdd(value)}
            disabled={disabled || !declarationsEnabled}
          >
            +{value}
          </Button>
        ))}
        <Button
          variant="destructive"
          className="h-10 text-sm mt-auto"
          onClick={onClear}
          disabled={disabled}
        >
          Clear
        </Button>
      </div>
    </div>
  );
}
